import { render, staticRenderFns } from "./edit-service-project.vue?vue&type=template&id=c3d6c358&scoped=true&"
import script from "./edit-service-project.vue?vue&type=script&lang=js&"
export * from "./edit-service-project.vue?vue&type=script&lang=js&"
import style0 from "./edit-service-project.vue?vue&type=style&index=0&id=c3d6c358&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c3d6c358",
  null
  
)

export default component.exports